import * as ACTION_TYPES from '../types';

let initialState = {
  merchantList: [],
  merchant: {},
  loading: false,
  error: false
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_MERCHANTS:
        return { ...state, merchantList: action.data };
      case ACTION_TYPES.RESET_MERCHANT:
        return { ...state, merchantList: [] };
      case ACTION_TYPES.GET_MERCHANT:
        return { ...state, merchant: action.data }
      default:
        return state;
    }
  };